'use client'

import { useMemo } from 'react'

import {
  AnalyticsEntityType,
  AnalyticsSource,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

import { BaseCarousel } from '@/components/common/carousel/BaseCarousel'
import { InsideGroupWrapper } from '@/components/common/carousel/InsideGroupWrapper'
import { useListingSearch } from '@/components/listings/search/ListingSearchProvider'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'
import { sortListingsByIdOrder } from '@/queries/listingSearchQuery'

export default function HomepageRecentlyViewedCarousel({
  insideGroup = false,
}: {
  insideGroup?: boolean
}) {
  const { data, isLoading, state } = useListingSearch()
  const { track } = useAnalytics()

  // The search API doesn't preserve the order of the requested `id` list,
  // so the LIFO order (state.id) has to be re-applied to the results here.
  const orderedData = useMemo(() => {
    if (!data || !state.id) return data
    return { ...data, listings: sortListingsByIdOrder(data.listings, state.id) }
  }, [data, state.id])

  const handleViewAllClick = () => {
    track('button_click', {
      button_name: 'carousel_view_all',
      carousel_name: 'recently-viewed',
      screen_name: 'homepage',
      source: AnalyticsSource.HOME_PORTAL,
      entityType: AnalyticsEntityType.BUYER,
    })
  }

  const carousel = (
    <BaseCarousel
      data={orderedData}
      isLoading={isLoading}
      title={<FormattedMessage id="Common.Carousel.recentlyViewedTitle" />}
      carouselName="recently-viewed"
      screenName="homepage"
      onViewAllClick={handleViewAllClick}
    />
  )

  return insideGroup ? (
    <InsideGroupWrapper>{carousel}</InsideGroupWrapper>
  ) : (
    carousel
  )
}
